'use client';

import { useBunja } from 'bunja/react';
import { useEffect } from 'react';

import { spotTickerBunja } from '@flipster/r230522/original/spot-ticker';

export interface SubscribeSpotTickerProps {
  symbol: string;
}
const SubscribeSpotTicker = ({ symbol }: SubscribeSpotTickerProps) => {
  const { setCurrentTicker } = useBunja(spotTickerBunja);
  useEffect(() => setCurrentTicker(symbol), [setCurrentTicker, symbol]);
  return null;
};

export default SubscribeSpotTicker;
